<template>
  <v-card
    class="info-message ma-3 pa-6"
  >
    <v-row class="pa-4 body-2 align-center">
      <v-col class="px-0">
        <span class="font-weight-bold coolgray--text">
          {{ statusMessage }}
        </span>
      </v-col>
    </v-row>

    <v-row
      v-if="statusMessage === 'Error Unknown'"
      class="pa-4 body-2 coolgray--text font-weight-medium"
    >
      <v-col>
        <span>
          To report your experience,
          <a href="mailto:iadops@oao.freshdesk.com">contact us</a>.
          Outline the steps to reproduce the issue,
          and attach screenshots when possible.
        </span>
      </v-col>
    </v-row>

    <v-row
      v-else-if="associationId"
      class="pa-4 caption font-weight-medium"
    >
      <v-col>
        <v-row>
          <span class="font-weight-bold coolgray--text">
            Suggested Next Steps
          </span>
        </v-row>

        <v-row>
          <span>
            <router-link
              :to="`/dashboard?associationId=${associationId}&reportPath=all-data&subId=${subId}`"
            >Visit the publisher's dashboard</router-link>
          </span>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
const { createNamespacedHelpers } = require('vuex')

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapGetters: mapLayoutGetters } = createNamespacedHelpers('layout')
const { mapState: mapToolsState } = createNamespacedHelpers('tools')

export default {
  name: 'ErrorUnknown',
  props: {
    statusMessage: {
      type: String,
      default: 'Error Unknown',
    },
  },
  computed: {
    ...mapAuthGetters(['inDarkMode']),
    ...mapLayoutGetters(['textColor']),
    ...mapToolsState({
      associationId: (state) => state.associationId,
      subId: (state) => state.subId,
    }),
  },
  methods: {
    focusInput() {
      this.$refs.searchInput.focus()
    },
  },
}
</script>
